import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SendMail } from '../../Contact';
import './contactform.scss'

const ContactForm = () => {
    const { register, handleSubmit, reset, errors } = useForm();
    const [success, setSuccess] = useState({});
    const onSubmit = (data, e) => {
        console.log(data)
        SendMail(data).then(data => {
            setSuccess(data)
            if (data.status === true) {
                e.target.reset();

            }
        })
    };
    return (
        <div className="contact-form">
            <div className="container">
                <div className="contact-flex">
                    <div className="contact-box contact-info">
                        <h1>Get a quote</h1>
                        <p>Fill up the form and i will get back to you within 24 hours.</p>


                        <div className="contact-address">
                            <ul className="address">
                                <li><FontAwesomeIcon className="icon-contact" icon='phone' />+880 1815 566398</li>
                                <li><FontAwesomeIcon className="icon-contact" icon='envelope' /><a href="mailto:mawlaariful@gmail.com">ari.mowla@gmail.com</a></li>
                                <li><FontAwesomeIcon className="icon-contact" icon='map-marker-alt' />  Chittagong, BD</li>
                            </ul>

                            <ul className="social-btn">
                                <li><a href="https://facebook.com/nokibrokes" target="_blank"><FontAwesomeIcon className="icon-social" icon={['fab', 'facebook-f']} /></a></li>
                                <li><a href="https://twitter.com/arifulmowla" target="_blank"><FontAwesomeIcon className="icon-social" icon={['fab', 'twitter']} /></a></li>
                                <li><a href="https://instagram.com/nokibrokes" target="_blank"><FontAwesomeIcon className="icon-social" icon={['fab', 'instagram']} /></a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="contact-box">
                        <div className="contact-form-input">
                            <form onSubmit={handleSubmit(onSubmit)}>

                                <div className="form-group">
                                    <label htmlFor="name">Your Name</label>
                                    <input className="form-control" name="name" ref={register({ required: true })} placeholder="eg. John Doe" />
                                    {errors.name && <span>This field is required</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="mail">Your Email</label>
                                    <input className="form-control" name="_replyto" ref={register({ required: true })} placeholder="eg. example@mail.com" />
                                    {errors._replyto && <span>This field is required</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message">Message</label>
                                    <textarea className="form-control form-text-area" name="message" ref={register({ required: true })} placeholder="Hello," rows="10" />
                                    {errors.message && <span>This field is required</span>}
                                </div>
                                {success.status && <span>{success.message}</span>}
                                <button className="btn btn-secondary btn-contact">SEND</button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;